import type { ApiTypingsLookup } from "@/api";

import {
  previewShortLink,
  previewShortLinkClicks,
  previewShortLinkDomains,
  previewShortLinkMetrics,
  previewShortLinkQr,
  previewShortLinkTags,
  previewShortLinkTimeSeries,
  previewShortLinks,
} from "../short-links/data";

export function handleGetShortLinks(): ApiTypingsLookup["get_short_links"]["response"] {
  return previewShortLinks();
}

export function handleGetShortLink(
  params: ApiTypingsLookup["get_short_link"]["request"],
): ApiTypingsLookup["get_short_link"]["response"] {
  return previewShortLink(params.shortLinkId);
}

export function handleGetShortLinkTags(): ApiTypingsLookup["get_short_link_tags"]["response"] {
  return previewShortLinkTags();
}

export function handleGetShortLinkDomains(): ApiTypingsLookup["get_short_link_domains"]["response"] {
  return previewShortLinkDomains();
}

export function handleGetShortLinkClicks(
  params: ApiTypingsLookup["get_short_link_clicks"]["request"],
): ApiTypingsLookup["get_short_link_clicks"]["response"] {
  return previewShortLinkClicks(params.shortLinkId);
}

export function handleGetShortLinkTimeSeries(
  params: ApiTypingsLookup["get_short_link_time_series"]["request"],
): ApiTypingsLookup["get_short_link_time_series"]["response"] {
  return previewShortLinkTimeSeries(params.params, params.granularity);
}

export function handleGetShortLinkMetrics(
  params: ApiTypingsLookup["get_short_link_metrics"]["request"],
): ApiTypingsLookup["get_short_link_metrics"]["response"] {
  return previewShortLinkMetrics(params.field);
}

export function handlePreviewShortLinkQr(
  params: ApiTypingsLookup["preview_short_link_qr"]["request"],
): ApiTypingsLookup["preview_short_link_qr"]["response"] {
  return previewShortLinkQr(params.format);
}
